export const REGEX = {
  DIGITS: /^[0-9]+$/,
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  REGISTRATION_PASSWORD: /(?=.*\d)(?=.*[A-Z])/g,
  VERIFICATION_CODE: /^[0-9]{6,6}$/,
  ZIP_CODE: /^[0-9]{5}$/,
} as const
